import { Box, Card, CardContent, FormControlLabel, Grid, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@material-ui/core";
import DialogComponent from "../../../../../components/Dialog"
import { getTranslation } from "../../../../../heplers/translationHelper";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import { useEffect, useState } from "react";
import { Get, Post } from "../../../../../actions";
import { useSnackbar } from "notistack";
import { DatePicker } from "../../../../../components/DatePicker";
import dayjs from "dayjs";
import MonthYearPicker from "../../../../../components/MonthYearPicker";
import { format } from "../../../../../heplers/format";
import LocaleNumberField from "../../../../../components/LocaleNumberField";
import { IndexationDetails } from "./IndexationDetails";
import { Get_Tanenet_URL } from "../../../../../constants/apiUrls";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

// round a computed value to 2 decimals, returning a canonical Number.
const to2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export const EditManualIndexationDialog = ({ open,startDate,editIndexation, tenantId, onClose }) => {
    const [indexationProposal, setIndexationProposal] = useState({
        startDate: null,
        oldIndex: 0,
        newIndex: 0,
        newProposal: 0,
        oldRent: 0,
        newRent: 0,
        month: dayjs().month() - 1,
        year: dayjs().year() + 1,
        percentage: 100,
        baseCode: 2013,
        additionalPayments: []

    });

    useEffect(()=>{
        if(editIndexation)
            setIndexationProposal({...editIndexation,month:dayjs(editIndexation.startDate).month(),year:dayjs(editIndexation.startDate).year()})
    },[editIndexation])

    const [isSubmitting, setIsSubmitting] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [tenant, setTenant] = useState();

    const loadIndexationProposal = (month, year, baseCode) => {
        if (startDate)
            Post(
                { tenantId: tenantId, startDate: dayjs(startDate).format("YYYY-MM-DD"), month: month, year: year, baseCode: baseCode },
                "Indexation/GetNewIndexationProposal",
                null,
                (resp) => {
                    setIndexationProposal(resp.data);
                },
                (error) => {
                    enqueueSnackbar(
                        getTranslation(
                            "Something went wrong. Please contact with admin.",
                            "Something went wrong. Please contact with admin.",
                            "Something went wrong. Please contact with admin."
                        ),
                        {
                            variant: "error",
                        }
                    );
                }
            );
    };

    useEffect(() => {
                Get(
            { tenantId: tenantId },
            Get_Tanenet_URL,
            null,
            (resp) => {
                setTenant(resp?.data);
            },
            (error) => {
                enqueueSnackbar(error?.data, { variant: "error" });
            }
        );
    }, [tenantId]);


    return <DialogComponent
        maxWidth="lg"
        title={getTranslation("Add Manual Indexation", "Add Manual Indexation", "Add Manual Indexation")}
        open={open}
        onClose={() => {
            onClose();
        }}
    >
        <Card>
            <CardContent>
                <Formik
                    enableReinitialize
                    initialValues={indexationProposal}
                    validationSchema={Yup.object({
                        oldIndex: Yup.number().required("Required"),
                        newIndex: Yup.number().required("Required"),
                        newProposal: Yup.number().required("Required"),
                        oldRent: Yup.number().required("Required"),
                        newRent: Yup.number().required("Required"),
                        percentage: Yup.number().required("Required")
                    })}
                    onSubmit={(values, actions) => {
                        Post({ ...values, tenantId: tenantId },
                            "Indexation/EditManual",
                            null,
                            resp => {
                                enqueueSnackbar(resp.data, { variant: "success" })
                                actions.setSubmitting(false)
                                onClose()
                            },
                            error => {
                                enqueueSnackbar(error.data, { variant: "error" })
                                actions.setSubmitting(false)

                            }
                        )
                    }}
                >
                    {({
                        errors,
                        touched,
                        values,
                        handleSubmit,
                        isSubmitting,
                        getFieldProps,
                        setFieldValue,
                    }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={6} lg={6}>

                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Box display="flex" justifyContent="flex-end">

                                        <Box component={Paper} borderRadius={2} boxShadow={3} p={2}>

                                            <TableContainer>
                                                <Table size="small" style={{
                                                    borderCollapse: "collapse",
                                                }}>
                                                    <TableBody>
                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                            border: 'none'
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, width: "40%", border: 'none' }} >Apartment No:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.apartmentNo}</TableCell>
                                                        </TableRow>

                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, border: 'none' }}>Address:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.aparmentAddress}</TableCell>
                                                        </TableRow>

                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, border: 'none' }}>PEB:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.aparmentPEB}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <DatePicker
                                        disabled
                                        label="Contract Start Date"
                                        value={values.startDate}
                                        required
                                        onChange={(newDate) => {
                                            if (dayjs(newDate.toString()) < dayjs(startDate.toString())) {
                                                enqueueSnackbar("Indexation cannot be applied prior to the contract start date.", { variant: 'info' })
                                                setFieldValue("startDate", startDate.toString());
                                                return;
                                            }
                                            setFieldValue("startDate", newDate.toString());
                                            // setStartDate(newDate)
                                            // if (dayjs(newDate).isValid()) {
                                            //     var date = dayjs(newDate)
                                            //     setFieldValue("year", date.year() + 1);
                                            //     setFieldValue("month", date.month() - 1);
                                            //    // setTimeout(loadIndexationProposal(date.month() + 1, date.year() + 1, values.baseCode), 1000)
                                            // }
                                        }}
                                        size='small'
                                        helperText="It will not effect previous added records but will effect upcoming."
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <MonthYearPicker
                                        value={{ month: values.month, year: values.year }}
                                        initialDate={values.startDate}
                                        onMonthChange={(m) => {
                                            loadIndexationProposal(m, values.year, values.baseCode, values.startDate)
                                            setFieldValue("month", m)
                                        }}
                                        onYearChange={(y) => {
                                            loadIndexationProposal(values.month, y, values.baseCode, values.startDate)
                                            setFieldValue("year", y)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="oldIndex"
                                        label="Old Index"
                                        value={values.oldIndex}
                                        onChange={(e) => {
                                            const oldIndex = e.target.value;
                                            const newRent = to2((oldIndex * values.newRent) / values.oldIndex);
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("oldIndex", oldIndex)
                                        }}
                                        error={touched.oldIndex && Boolean(errors.oldIndex)}
                                        helperText={touched.oldIndex && errors.oldIndex}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="newIndex"
                                        label="New Index"
                                        value={values.newIndex}
                                        onChange={(e) => {
                                            const newIndex = e.target.value;
                                            const newRent = to2((values.oldRent * newIndex) / values.oldIndex);
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("newIndex", newIndex)
                                        }}
                                        error={touched.newIndex && Boolean(errors.newIndex)}
                                        helperText={touched.newIndex && errors.newIndex}
                                    />
                                </Grid>

                                {/* <Grid item xs={12} sm={6}>
                                    <Field
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        {...getFieldProps("newProposal")}
                                        as={TextField}
                                        fullWidth
                                        type="number"
                                        name="newProposal"
                                        label="New Proposal"
                                        error={touched.newProposal && Boolean(errors.newProposal)}
                                        helperText={touched.newProposal && errors.newProposal}
                                    />
                                </Grid> */}

                                {/* <Grid item xs={12} sm={6}>
                                    <Field
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // {...getFieldProps("oldRent")}
                                        value={values.oldRent}
                                        as={TextField}
                                         onChange={(e) => {
                                             var newProposal = (e.target.value * values.newIndex) /(values.oldIndex);

                                            // var newProposal = (values.oldRent * values.newIndex) / (values.oldIndex);
                                            // console.log("asdasdadadad", newProposal)
                                            // var newRent = ((newProposal - values.oldRent) * (e.target.value / 100)) + values.oldRent;
                                            setFieldValue("newRent", newProposal.toFixed(2))
                                            setFieldValue("oldRent", e.target.value)
                                        }}
                                        fullWidth
                                        type="number"
                                        name="oldRent"
                                        label="Old Rent"
                                        error={touched.oldRent && Boolean(errors.oldRent)}
                                        helperText={touched.oldRent && errors.oldRent}
                                    />
                                </Grid> */}

                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="percentage"
                                        label="Percentage"
                                        value={values.percentage}
                                        onChange={(e) => {
                                            const percentage = e.target.value;
                                            const newRent = to2((values.newProposal - values.oldRent) * (percentage / 100) + values.oldRent)
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("percentage", percentage)
                                        }}
                                        error={touched.percentage && Boolean(errors.percentage)}
                                        helperText={touched.percentage && errors.percentage}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={6}>
                                    <Field
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={values.newRent}
                                        // {...getFieldProps("newRent")}
                                        min={values.oldRent}
                                        onChange={(e)=>{
                                             var newProposal = (values.oldRent * values.newIndex) /(values.oldIndex);
                                            var percentage=((e.target.value-values.oldRent)/(newProposal-values.oldRent))*100
                                             setFieldValue("percentage",percentage)
                                             setFieldValue("newRent",e.target.value)

                                        }}
                                        as={TextField}
                                        fullWidth
                                        type="number"
                                        name="newRent"
                                        label="New Rent"
                                        error={touched.newRent && Boolean(errors.newRent)}
                                        helperText={touched.newRent && errors.newRent}
                                    />
                                </Grid> */}
                                <Grid item xs={12} lg={12} md={12}>
                                    <IndexationDetails
                                        fundsArray={values.additionalPayments}
                                        oldRent={values.oldRent}
                                        newRent={values.newRent}
                                        percentage={values.percentage}
                                        increaseAmount={(values.newProposal - values.oldRent)*(values.percentage/100.00)}
                                    />

                                </Grid>

                            </Grid>
                            <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                }}
                            >
                                <ButtonWithLoading
                                    title={
                                        <Typography
                                            variant="h5"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            {getTranslation(
                                                "Submit Manual",
                                                "Submit Manual",
                                                "Submit Manual"
                                            )}
                                        </Typography>
                                    }
                                    size="small"
                                    variant="contained"
                                    loading={isSubmitting}
                                    // disabled={rentAmountError}
                                    // onClick={handleSubmit}
                                    onClick={handleSubmit}
                                    style={{
                                        boxShadow: "4px 4px 10px 0px rgba(0, 0, 0, 0.1)",
                                        padding: "12px 10px 12px 8px",
                                        // background: "rgb(251,94,57)",
                                        background: "rgb(251,94,57)",
                                        display: values.newRent == 0 ? "none" : "",
                                        borderRadius: "20px",
                                        width: "230px",
                                    }}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>

            </CardContent>
        </Card>
    </DialogComponent>
}